import React, { Component } from 'react'
import { Row, Col, Icon, Button } from 'antd'
import AuthModel from '../models/AuthModel'
import apaLogo from '../assets/images/apalogo_big.png'

const DemoBox = props => <p style={{height: `${props.value}px`, textAlign: 'center'}}>{props.children}</p>;

class PublicPreForm extends Component {

    setAnonymous() {
        const { history } = this.props;
        history.push('/publico');
    }

    render() {
        return (
            <Row>
                <Col span={24}>
                    <div>
                        <h1>
                            <img src={apaLogo} alt="APA Logo" title="APA Logo" style={{float: 'left', marginRight: '20px'}}/>
                            Reporte de Ocorrências no Litoral
                        </h1>
                        <hr style={{clear: 'both'}} />

                        <h2 style={{textAlign: 'center'}}>Como Pretende Reportar?</h2>
                        <Row type="flex" justify="space-around" align="middle" style={{marginTop: '25px'}}>
                          <Col span={12}><DemoBox value={100}>
                              <Button type="default"
                                  style={{margin: '0 auto'}}
                                  onClick={(e) => this.setAnonymous()}>
                                  <Icon type="create" style={{color: 'green'}} /> Área do Cidadão
                              </Button>
                          </DemoBox></Col>
                          <Col span={12}><DemoBox value={100}>
                              <Button type="primary"
                                  style={{margin: '0 auto'}}
                                  onClick={(e) => {AuthModel.lastRoute = '/issue'; this.props.history.push('/login');}}>
                                  <Icon type="create" style={{color: 'blue'}} /> Técnico Registado
                              </Button>
                          </DemoBox></Col>
                        </Row>

                    </div>
                </Col>
            </Row>
        )
    }
}

export default PublicPreForm;



// WEBPACK FOOTER //
// ./src/components/PublicPreForm.js